import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { SearchResultType } from '../search/search-result-type'

@Component({
  selector: 'app-search-results-dialog',
  templateUrl: './search-results-dialog.component.html',
  styleUrls: ['./search-results-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchResultsDialogComponent {
  dataTypes = SearchResultType

  constructor(
    public dialogRef: MatDialogRef<SearchResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { type: SearchResultType; results: any[] }
  ) {}

  onClose(): void {
    this.dialogRef.close()
  }
}
